import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { MotesMediaComponent } from './motes-media';
import { LightImageModule } from '../light-image/light-image.module';
import { LoadingComponentModule } from '../loading/loading.module';

@NgModule({
    declarations: [
        MotesMediaComponent,
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        LightImageModule,
        LoadingComponentModule
    ],
    exports: [
        MotesMediaComponent
    ]
})
export class MotesMediaModule { }
